export default "__VITE_ASSET__DXih6ZK4__"